import React from 'react';

import { Form, Spin } from 'antd';
import { merge } from 'lodash';

import { useParams } from 'react-router-dom';

import { filterPayloadByPermissions } from '@app/services/filterPayloadByPermissions';
import { FieldGroupRender, getInitialValues } from '@components/FieldGroupRender';
import { useGetOrderQuery, useGetProcessQuery } from '@pages/Processes/hooks';
import { useOrderItems } from '@pages/Processes/pages/Orders/providers';

import { ItemsTable } from '../ItemsTable';

interface IProps {
  onFinish: (data: any) => void;
}

export const OrderForm: React.FC<IProps> = (props) => {
  const [form] = Form.useForm();
  const params = useParams<{ orderId: string; processId: string }>();

  const { data: orderData, isLoading: orderLoading } = useGetOrderQuery(params?.orderId || '');
  const { data: processData, isLoading: processLoading } = useGetProcessQuery(params.processId);
  const { items, setArtifactUid, setItems } = useOrderItems();
  const itemsArtifactUid = processData?.order_structure?.items?.find((el: any) => el?.data?.type === 'order_items')
    ?.data?.uid;
  const catalogUID = (orderData as any)?.field_groups?.general?.catalog?.uid;
  const authorId = (orderData as any)?.field_groups?.general?.author?.id;
  const itemsAvailable = itemsArtifactUid ? !!orderData?.$artifacts?.[itemsArtifactUid]?.update : false;
  const itemsArtifactData = itemsArtifactUid ? (orderData?.artifacts?.[itemsArtifactUid] as any) : undefined;

  React.useEffect(() => {
    if (itemsArtifactUid) {
      setItems(itemsArtifactData?.items);
      setArtifactUid(itemsArtifactUid);
    }
  }, [orderData, itemsArtifactUid]);

  const handleSubmit = async (values: any): Promise<void> => {
    const payload = merge(values, {
      artifacts: {
        [`${itemsArtifactUid}`]: {
          items: items?.map((item: any) => ({ product_uid: item?.product?.uid, quantity: item?.quantity })),
        },
      },
      version: orderData?.version,
    });
    props.onFinish({
      order_uid: orderData?.uid || '',
      data: filterPayloadByPermissions(payload, orderData?.$field_groups, orderData?.$artifacts),
    });
  };

  const EDITABLE_ITEMS =
    processData?.order_structure?.items.filter((el) => {
      if (el.type === 'field_group' && !orderData?.$field_groups?.[el.data.alias || el.data.uid].update) {
        return;
      }
      return el;
    }) || [];

  if (orderLoading || processLoading) {
    return <Spin />;
  }

  return (
    <>
      <Form
        form={form}
        name="updateOrder"
        id="updateOrder"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 8 }}
        initialValues={{ ...getInitialValues(orderData, processData) }}
        onFinish={handleSubmit}>
        {processData && (
          <FieldGroupRender
            form={form}
            items={EDITABLE_ITEMS}
            fieldGroupPermissions={orderData?.$field_groups}
            order_uid={params.orderId}
          />
        )}
        {/* <Form.Item noStyle shouldUpdate> */}
        {/*   {() => ( */}
        {/*     <Typography> */}
        {/*       <pre>{JSON.stringify(form.getFieldsValue(), null, 2)}</pre> */}
        {/*     </Typography> */}
        {/*   )} */}
        {/* </Form.Item> */}
      </Form>
      {itemsAvailable && (
        <ItemsTable
          catalogUID={catalogUID}
          show_multiplicity_indicator={itemsArtifactData?.show_multiplicity_indicator}
          authorId={authorId}
        />
      )}
    </>
  );
};
